export default "__VITE_ASSET__qAu7WGM8__"